import React from 'react';
import { ChevronLeft, ChevronRight, Calendar } from 'lucide-react';

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export function MonthSelector({ year, month, onChange }) {
  // month: 0-11 or null (null = All)
  const isAll = month === null;

  const handlePrev = () => {
    if (isAll) return;
    if (month === 0) onChange(year - 1, 11);
    else onChange(year, month - 1);
  };

  const handleNext = () => {
    if (isAll) return;
    if (month === 11) onChange(year + 1, 0);
    else onChange(year, month + 1);
  };

  return (
    <div className="flex items-center gap-1 bg-[hsl(var(--surface-elevated))] border border-[hsl(var(--border))] rounded-lg p-0.5 overflow-x-auto" data-testid="month-selector">
      <button
        onClick={() => onChange(year, null)}
        className={`px-2.5 py-1.5 rounded-md text-[10px] font-semibold transition-all whitespace-nowrap ${isAll ? 'bg-[#E63946] text-white' : 'text-[hsl(var(--text-muted))] hover:text-white'}`}
        data-testid="month-all"
      >
        All {year}
      </button>
      {MONTHS.map((m, i) => (
        <button
          key={i}
          onClick={() => onChange(year, i)}
          className={`px-2 py-1.5 rounded-md text-[10px] font-semibold transition-all whitespace-nowrap ${month === i ? 'bg-[#E63946] text-white' : 'text-[hsl(var(--text-muted))] hover:text-white'}`}
          data-testid={`month-${i}`}
        >
          {m}
        </button>
      ))}
    </div>
  );
}

export function filterByMonth(items, year, month, dateField = 'created_at') {
  if (month === null) {
    // All year
    return items.filter(item => {
      const d = new Date(item[dateField]);
      return d.getFullYear() === year;
    });
  }
  return items.filter(item => {
    const d = new Date(item[dateField]);
    return d.getFullYear() === year && d.getMonth() === month;
  });
}
